"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackleLog = void 0;
var Hackle = require("@hackler/javascript-sdk");
var utils_1 = require("./utils");
var HackleLog = /** @class */ (function () {
    function HackleLog(hackle_key) {
        var _this = this;
        this.getHackleUserData = function () {
            return {
                "id": (0, utils_1.getCookie)("device_id"),
                "deviceId": (0, utils_1.getCookie)("device_id"),
                "userId": (0, utils_1.getJSONfromUserInfoCookie)()["_id"]
            };
        };
        this.send = function (key, data) {
            if (data === void 0) { data = {}; }
            var event = { key: key, properties: data };
            var user = _this.getHackleUserData();
            _this._client.track(event, user);
        };
        this._client = Hackle.createInstance(hackle_key, {
            debug: false,
            auto_track_page_view: true
        });
    }
    return HackleLog;
}());
exports.HackleLog = HackleLog;
